import { inject, computed } from 'vue'

/**
 * @returns {Object}
 * Returns the media query values. It depends on the
 * provider of the MediaQueryRoot mixin.
 */
export default () => {
  const getIsMobile = inject('getIsMobile')
  const isMobile = computed(() => getIsMobile())

  const getIsTablet = inject('getIsTablet')
  const isTablet = computed(() => getIsTablet())

  const getIsSafari = inject('getIsSafari')
  const isSafari = computed(() => getIsSafari())

  const getIsIOS = inject('getIsIOS')
  const isIOS = computed(() => getIsIOS())

  const getIsXsMobile = inject('getIsXsMobile')
  const isXsMobile = computed(() => getIsXsMobile())

  return {
    isMobile,
    isTablet,
    isSafari,
    isIOS,
    isXsMobile
  }
}
